// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.udw0LHDFE6jfhP3_8c_7 .zPNt4Jv0f9zzJWvJvUro {
    transition: opacity 0.3s ease-in-out;
}

.X1BadD6o0JSGHp5GZ0eZ {
    transition: transform 0.3s ease-in-out;
}

.fyEBfoaH8wwOjjYzk7H9 {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    background-color: rgba(0, 0, 0, 0.85);
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    animation: L4oH9Iz36hU4Yu5UJpqt 0.3s ease-in-out;
    padding: 1rem;
}

@keyframes L4oH9Iz36hU4Yu5UJpqt {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.DPkoRe8C82gflnLTZJOd {
    background-color: white;
    padding: 2rem;
    border-radius: 0.5rem;
    max-width: 675px;
    text-align: center;
}

.DPkoRe8C82gflnLTZJOd h2 {
    margin: 0 0 0.5rem;
}

.DPkoRe8C82gflnLTZJOd form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 1rem;
}

.DPkoRe8C82gflnLTZJOd label {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.jpo00JFOfA8dSXLGPiEw {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    width: 100%;
}

.jpo00JFOfA8dSXLGPiEw label {
    width: 50%;
}

.XrqG0m1k6JymhOv1XvF5 {
    max-width: 25rem;
    margin: auto;
}

.XrqG0m1k6JymhOv1XvF5 {
    margin-bottom: 1rem;
}

.DPkoRe8C82gflnLTZJOd button {
    width: 100%;
    min-height: 67.5px;
}


.udw0LHDFE6jfhP3_8c_7 .Dw2R659U7QV6Zu6SzVeH {
    transition: transform 0.3s ease-in-out;
}

.udw0LHDFE6jfhP3_8c_7:hover .Dw2R659U7QV6Zu6SzVeH {
    transform: translateX(0.5rem);
}

.udw0LHDFE6jfhP3_8c_7:disabled {
    opacity: 0.75;
}

.udw0LHDFE6jfhP3_8c_7 {
    margin-top: 1rem;
}

.J0A0diC6qZllihi8CuC4 {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 1rem;
}

.J0A0diC6qZllihi8CuC4 button {
    margin: 0;
}

.J0A0diC6qZllihi8CuC4 button,
.J0A0diC6qZllihi8CuC4 button span {
    font-size: clamp(0.80rem, 1vw - 0.25rem, 1rem);
}

@media screen and (max-width: 768px) {
    .DPkoRe8C82gflnLTZJOd {
        width: 100%;
        max-height: 90vh;
        overflow-y: scroll;
    }

    .jpo00JFOfA8dSXLGPiEw {
        flex-wrap: wrap;
    }

    .jpo00JFOfA8dSXLGPiEw>label {
        width: 100%;
    }

    .XrqG0m1k6JymhOv1XvF5 {
        font-size: 0.75rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/ModalThankYou/ModalThankYou.module.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;AACxC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,qCAAqC;IACrC,WAAW;IACX,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gDAAkC;IAClC,aAAa;AACjB;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;;AAGA;IACI,sCAAsC;AAC1C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;;IAEI,8CAA8C;AAClD;;AAEA;IACI;QACI,WAAW;QACX,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".button .text {\n    transition: opacity 0.3s ease-in-out;\n}\n\n.icon {\n    transition: transform 0.3s ease-in-out;\n}\n\n.background {\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 100;\n    background-color: rgba(0, 0, 0, 0.85);\n    width: 100%;\n    height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    animation: fadeIn 0.3s ease-in-out;\n    padding: 1rem;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n.modal {\n    background-color: white;\n    padding: 2rem;\n    border-radius: 0.5rem;\n    max-width: 675px;\n    text-align: center;\n}\n\n.modal h2 {\n    margin: 0 0 0.5rem;\n}\n\n.modal form {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    margin-bottom: 1rem;\n}\n\n.modal label {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n\n.row {\n    display: flex;\n    flex-direction: row;\n    gap: 1rem;\n    width: 100%;\n}\n\n.row label {\n    width: 50%;\n}\n\n.description {\n    max-width: 25rem;\n    margin: auto;\n}\n\n.description {\n    margin-bottom: 1rem;\n}\n\n.modal button {\n    width: 100%;\n    min-height: 67.5px;\n}\n\n\n.button .arrow {\n    transition: transform 0.3s ease-in-out;\n}\n\n.button:hover .arrow {\n    transform: translateX(0.5rem);\n}\n\n.button:disabled {\n    opacity: 0.75;\n}\n\n.button {\n    margin-top: 1rem;\n}\n\n.button-group {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    gap: 1rem;\n}\n\n.button-group button {\n    margin: 0;\n}\n\n.button-group button,\n.button-group button span {\n    font-size: clamp(0.80rem, 1vw - 0.25rem, 1rem);\n}\n\n@media screen and (max-width: 768px) {\n    .modal {\n        width: 100%;\n        max-height: 90vh;\n        overflow-y: scroll;\n    }\n\n    .row {\n        flex-wrap: wrap;\n    }\n\n    .row>label {\n        width: 100%;\n    }\n\n    .description {\n        font-size: 0.75rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `udw0LHDFE6jfhP3_8c_7`,
	"text": `zPNt4Jv0f9zzJWvJvUro`,
	"icon": `X1BadD6o0JSGHp5GZ0eZ`,
	"background": `fyEBfoaH8wwOjjYzk7H9`,
	"fadeIn": `L4oH9Iz36hU4Yu5UJpqt`,
	"modal": `DPkoRe8C82gflnLTZJOd`,
	"row": `jpo00JFOfA8dSXLGPiEw`,
	"description": `XrqG0m1k6JymhOv1XvF5`,
	"arrow": `Dw2R659U7QV6Zu6SzVeH`,
	"button-group": `J0A0diC6qZllihi8CuC4`
};
export default ___CSS_LOADER_EXPORT___;
